<template>
  <div id="home">
    <div class="hero front-hero"></div>

    <section class="cta" style="text-align: center">
      <div class="info-container">
        <h1>Bonny Oaks Foundation</h1>
        <p style="text-align: left">
          Bonny Oaks Foundation is a nonprofit corporation which consists of a Board of Directors. Our main purpose and responsibility is to secure adequate reliable information regarding any applicant requesting benefits from the Foundation by furnishing approved forms for the applicants.
        </p>

        <router-link class="button" tag="a" to="/about-us">Learn More</router-link>
      </div>
    </section>

    <app-dual-image></app-dual-image>

    <section class="faq" style="text-align: center">
      <div class="info-container">
        <h1>Frequently Asked Questions</h1>
        <p>
          Have a question? Check out our Frequently Asked Questions.
        </p>

        <router-link class="button" tag="a" to="/questions-and-answers">View FAQs</router-link>
      </div>
    </section>

    <app-featured-images></app-featured-images>
  </div>
</template>

<script>
import DualImage from '../components/blocks/Dual-Image.vue'
import FeaturedImages from '../components/blocks/Featured-Images.vue'

export default {
  components: {
    'app-dual-image': DualImage,
    'app-featured-images': FeaturedImages
  }
}
</script>

<style scoped>
  main .hero {
    background-image: url('../assets/images/main_bg.jpg');
  }
</style>

